import { FC } from 'react'
import clsx from 'clsx'
import { Link, useSearchParams } from 'react-router-dom'
import { useLocation } from 'react-router'
import { checkIsActive, KTSVG, WithChildren } from '../../../../helpers'
import { useLayout } from '../../../core'

type Props = {
  to: string
  title: string
  icon?: string
  activeIcon?: string
  fontIcon?: string
  hasBullet?: boolean
  activePaths?: string[]
  disabled?: boolean // New disabled prop
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  activeIcon,
  fontIcon,
  hasBullet = false,
  activePaths,
  disabled = false, // Default to false if not provided
}) => {
  const { pathname } = useLocation()
  const [searchParams] = useSearchParams()
  const tab = searchParams.get('tab')
  const path = tab ? pathname + `?tab=${tab}` : pathname
  let isActive: boolean
  if (activePaths) {
    isActive = activePaths.some((activePath) => checkIsActive(path, activePath))
  } else {
    isActive = checkIsActive(path, to)
  }
  const { config } = useLayout()
  const { app } = config

  // Inline CSS for disabled state
  const disabledStyle: React.CSSProperties = disabled
    ? {
      pointerEvents: 'none', // Correct type for pointerEvents
      opacity: 0.6, // Adjust the opacity to indicate it's disabled
      cursor: 'not-allowed', // Change cursor to indicate the item is disabled
    }
    : {}

  return (
    <div className='menu-item'>
      <Link
        className={clsx('menu-link without-sub', { active: isActive, disabled: disabled })}
        to={disabled ? '#' : to} // If disabled, prevent navigation
        onClick={(e) => {
          if (disabled) e.preventDefault() // Prevent any action if disabled
        }}
        style={disabledStyle} // Apply the inline CSS when disabled
        aria-disabled={disabled} // Optional: for better accessibility
      >
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && activeIcon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className='menu-icon'>
            {isActive ? (
              <KTSVG path={activeIcon} className='svg-icon-2' />
            ) : (
              <KTSVG path={icon} className='svg-icon-2' />
            )}
          </span>
        )}
        {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
          <i className={clsx('bi fs-3', fontIcon)}></i>
        )}
        <span className='menu-title'>{title}</span>
      </Link>
      {children}
    </div>
  )
}

export { SidebarMenuItem }
